<template>
  <div>
    <button class="circleButton" @click="$emit('clickButton')">
      <span class="inner"><slot></slot></span>
    </button>
  </div>
</template>
<script>
export default {
  name: "CircleButton",
};
</script>
<style lang="scss" scoped>
.circleButton {
  width: 100%;
  display: block;
  padding-bottom: 100%;
  position: relative;
  outline: none;

  .inner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &::before {
      content: "";
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-color: $main-red;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      transform: scale(1);
      transition: transform 0.3s $easing-bounce;
    }
  }

  @media (hover: hover) {
    &:hover {
      .inner {
        &::before {
          transform: scale(1.12);
        }
      }
    }
  }
}
</style>
